import { Link } from "react-router-dom";

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link className="brand" to="/" aria-label="Kyndo home">
      <img src="/kyndo-mark.svg" alt="" width="36" height="36" />
      {!compact && (
        <span>
          kyndo<span className="brand-period">.</span>
        </span>
      )}
    </Link>
  );
}
